<template>
  <div class="select-option" :style="style">
    <label v-if="label" :for="id">{{ label }}</label>
    <select :id="id" :name="name" v-model="selectedValue" :disabled="disabled" class="form-control"
      @change="emitChange">
      <option v-if="placeholder" value="" selected>{{ placeholder }}</option>
      <option v-for="option in options" :key="option.value" :value="option.value"
        :disabled="currentlySelected == option.value">
        {{ option.name }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "SelectionComponent",
  props: {
    id: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      required: true,
    },
    valueKey: {
      type: [String, Number],
      default: "value",
    },
    labelKey: {
      type: String,
      default: "label",
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
    placeholder: {
      type: String,
      default: "Select an option",
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    currentlySelected: {
      type: String,
      default: ""
    },

    style: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selectedValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.selectedValue = newValue;
    },
  },
  methods: {
    emitChange() {
      this.$emit("input", this.selectedValue);
      this.$emit("change", this.selectedValue);
    },
  },
};
</script>

<style scoped>
.select-option {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}

.select-label {
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.select-input {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}
</style>
